import { useEffect, useRef } from "react";

import { IconDownload } from "@btnet/blueprint-icons";
import { BTText } from "@btnet/core-components";

import { ClientObservableBackgroundJobStatus } from "types/enum";

import { downloadUrlViaWebviewOrAnchor } from "utilities/document/fileDownload.utils";

import { type ClientObservableBackgroundJobDetails } from "commonComponents/utilities/ClientObservableBackgroundJobStatusPopup/ClientObservableBackgroundJobStatusPopup.types";

export function PlanSetDownloadItem({
    process,
}: Readonly<{ process: ClientObservableBackgroundJobDetails }>) {
    const isComplete = process.status === ClientObservableBackgroundJobStatus.Success;
    const downloadUrl = process.additionalData?.downloadUrl;
    const fileName = process.additionalData?.fileName ?? process.details;

    // Only fire the auto-download when status TRANSITIONS to Success during this
    // mount. If the component mounts already in Success (the user refreshed before
    // dismissing the popup; the backend still surfaces the terminal job in their
    // list), the download has already happened in a prior session and re-firing
    // would surprise the user with a duplicate file.
    const mountedAlreadyCompleteRef = useRef(isComplete);

    useEffect(() => {
        if (mountedAlreadyCompleteRef.current) return;
        if (isComplete && downloadUrl) {
            void downloadUrlViaWebviewOrAnchor(downloadUrl, fileName);
        }
    }, [isComplete, downloadUrl, fileName]);

    return (
        <div className="flex flex-row items-center gap-1">
            <IconDownload />
            <BTText size="normal-lg" text={process.details} />
        </div>
    );
}
